import { LoggedUser } from '../Models/LoggedUser';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { retry, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import {Azienda} from "../../Admin/models/Azienda";
import {environment} from "../../../environments/environment";
import {ApiPathsService} from "../../api-paths.service";
import {OneSignalService} from "../../onesignal.service";
import {GetFromLocalStorage} from "../../../environments/Utility/Utility";
import {ReverbService} from "../../reverb.service";

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<LoggedUser>;
  public currentUser: Observable<LoggedUser>;
  private isLogoutEnabled: boolean;
  environment= environment;
  constructor(
    private http: HttpClient,
    private router: Router,
    private apiPaths: ApiPathsService,
    private reverb: ReverbService,
  ) {
    this.currentUserSubject = new BehaviorSubject<LoggedUser>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
    this.isLogoutEnabled = true;
  }
  public get currentUserValue(): LoggedUser {
    return this.currentUserSubject.value;
  }
  public set currentUserValue(value: LoggedUser) {
    localStorage.setItem('currentUser', JSON.stringify(value));
    this.currentUserSubject.next(value);
  }

  updateUser(user){
    this.currentUserSubject.next(user);
  }
  getUserProfile(token, user: LoggedUser){
    if(user.ruoliObject.some(x=>x.id == 'C'))
      return this.http.post<any>(environment.apiUrl + '/anagrafica/profilo/cliente', {},{headers:{Authorization: `Bearer ${token}`}})
    else
      return this.http.post<any>(environment.apiUrl + '/anagrafica/profilo/persona', {},{headers:{Authorization: `Bearer ${token}`}})
  }
  getProfile(){
    if(this.currentUserSubject.value.ruoliObject.some(x=>x.id == 'C')){
     this.getUserProfile(this.currentUserSubject.value.access_token, this.currentUserSubject.value).subscribe(profile =>{
       var  user = {...this.currentUserSubject.value, ...profile};
       this.currentUserValue=user;
      });

    }else{
      this.http.post<any>(environment.apiUrl + '/anagrafica/profilo/persona', {},{headers:{Authorization: `Bearer ${this.currentUserSubject.value.access_token}`}}).subscribe(profile =>{
        var  user = {...this.currentUserSubject.value, ...profile};
        this.currentUserValue=user;
      });
    }
  }
login(username: string, password: string) : Observable<any>{
    return this.http.post<any>(environment.apiUrl + (environment.Wp ? '/jwt-auth/v1/token' : '/auth/login'), { username, password, deviceid: OneSignalService.isEnabled() ? localStorage.getItem(`osUserId-${OneSignalService.isEnabled()}`) :"default" })
      .pipe(map(user => {
        user.authdata = window.btoa(username + ':' + password);
        user.username = username;
        user.access_token = user.access_token? user.access_token : user.token;
        this.currentUserValue=user;
        if(user.ruoliObject?.some(ruolo => ruolo.id === 'AG'))
            this.LoginRma(user);
        console.log("UTENTE LOGGATO: ", user);
        return user;
      }));
  }

    LoginRma(user: any) {
        if (!environment.Modules['Rma'] || !environment.RmaAddOn || !environment.RmaAddOn['userPiattaformaAssistenza']) {
            return;
        }
        const auth = window.atob(user.authdata);
        const [username, password] = auth.split(':');
        const loginData = {username, password};
        const apiUrl = environment.RmaAddOn['linkPiattaformaAssistenza'] + '/api';
        this.apiPaths.ClassicPost('/auth/login', loginData, null, apiUrl).subscribe(data => {
            data.authdata = user.authdata;
            data.username = username;
            data.access_token = data.access_token || data.token;
            localStorage.setItem('rmaCurrentUser', JSON.stringify(data));
            console.log("UTENTE LOGGATO RMA: ", user);
        });
    }

  signUp(val:Azienda): Observable<any> {
    return this.http.post<any>(environment.apiUrl + (environment.Wp ? '/eventup/client/register' : '/auth/register'),
      JSON.stringify(val),{
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }
    ).pipe(map(user => {}));
  }
  verify(val): Observable<any> {
    return this.http.post<any>(environment.apiUrl + '/auth/check',
      JSON.stringify(val),{
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.currentUserValue.access_token}`
        }),
      }
    ).pipe(map(user => {}));
  }
  method(val): Observable<any> {
    return this.http.post<any>(environment.apiUrl + '/auth/check/method',
      JSON.stringify(val),{
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.currentUserValue.access_token}`
        }),
      }
    ).pipe(map(user => {}));
  }

  logout() {
    if(!this.currentUserValue?.access_token && this.currentUserValue?.verified != false) return;
    localStorage.removeItem('currentUser');
    localStorage.removeItem('rmaCurrentUser');
    this.currentUserSubject.next(null);
    this.reverb.disconnect();
    this.router.navigate([this.environment['unloggedHref'] ??  this.environment.href ?? '/Login']);

    return;
  }

  public get logoutEnabled(): boolean {
    return this.isLogoutEnabled;
  }

  public set logoutEnabled(val: boolean) {
    this.isLogoutEnabled = val;
  }

  public get username(): string {
    return this.currentUserValue.username;
  }
  isAmministrazione() {
    return this.currentUserValue && this.currentUserValue.ruoliObject.find(x => x.id === "A") !== undefined;
  };
  recoverpwd(email): Observable<any> {
    return this.http.post<any>(environment.apiUrl + (environment.Wp ? '/eventup/resetpwd' : '/auth/recover'), JSON.stringify({email: email}), {headers: new HttpHeaders({'Content-Type': 'application/json',}),})
      .pipe(map(data => {
        return data;
      }));
  }
  resend(email): Observable<any> {
    return this.http.post<any>(environment.apiUrl + (environment.Wp ? '/eventup/resetpwd' : '/auth/resend'), JSON.stringify({email: email}), {headers: new HttpHeaders({'Content-Type': 'application/json',}),})
      .pipe(map(data => {
        return data;
      }));
  }
  resetpwd(value): Observable<any> {
    return this.http.post<any>(environment.apiUrl + '/auth/reset', JSON.stringify(value),{headers: new HttpHeaders({'Content-Type': 'application/json',}),})
      .pipe(map(data => {
        return data;
      }));
  }

  updateuser(user){ this.currentUserSubject.next(user);}


}
